export enum ProviderTypes {
    POSIntegrated = 0,
    Paycom = 1,
    HotSchedules = 2,
    Adp = 3,
    Harri = 4,
    EnterpriseETime = 6,
  SevenShift = 8,
    Paylocity = 11,
    Netchex = 12,
    Ukg = 13,
    HarriAPI = 15
}
